import $ from 'jquery'

$( document ).on( 'bookwormgb_products_carousel_block_output_success', function( e, el ) {
	$( el ).each( function() {
		if( $( this ).find( '.js-slick-carousel' ).length ) {
			// initialization of slick carousel
			if ( $.HSCore.components.hasOwnProperty( 'HSSlickCarousel' ) ) {
				$.HSCore.components.HSSlickCarousel.init( $( this ).find( '.js-slick-carousel' ) )
			}
		}
	})
})